/**
 * Global preference type definitions for all Atoll-compliant frontends.
 *
 * PrefType enumerates all known preference categories across the ecosystem.
 * The prefs table (d_Users.attributes) is user-specific and application-agnostic —
 * all platforms store prefs in the same table, so all types are defined here.
 *
 * When a new platform (apestaart, kleos, etc.) needs new pref types, add them
 * to this enum. The shared definition is distributed to all projects via vivo.
 *
 * Moved from services/redux/prefsSlice.ts.
 */

export enum PrefType {
  User = 1,
  AdminStatus = 2,
  AdminSetting = 3,
  ServicesSettings = 4,
  TrendsSettings = 5,
  SputnikDeviceSettings = 6,
  NebulonSpreadConfig = 7,
  SputnikDeviceCommand = 8,
  TuyaScene = 9,
  SputnikDeviceStatus = 10,
  EventsSettings = 11,
}

export interface UpdateQueueItem {
  type?: PrefType;
  prefname?: string;
  keyaddress: string;
  keyvalue: any;
  tagid?: number;
}
